import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Pagination from "../ResuableCompoment/Pagination";
import SearchBar from "../ResuableCompoment/SearchBar";
import useApi from "../CustomHooks/useApi";
import { useSelector } from 'react-redux';

const AespTxn = () => {
    const [loading, setLoading] = useState(true);
    const [formsData, setFormsData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [rawResponse, setRawResponse] = useState([]);
    const itemsPerPage = 10;
    const navigate = useNavigate();

    const userId = useSelector((state) => state.auth.employeeDetails.userId);

    const { callApi: pendingOnboard } = useApi(
        `/itpay/aeps/backend/process-transaction`,
        "GET"
    );

    useEffect(() => {
        fetchFormsData();
    }, []);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchQuery]);

    const fetchFormsData = async () => {
        try {
            const response = await pendingOnboard(null, `?userId=${userId}`);

            console.log("responceeeee", response);
            if (response?.length > 0) {
                setFormsData(response);
                setRawResponse(response);
            } else {
                setFormsData([]);
            }
            setLoading(false);
        } catch (err) {
            console.error("Error fetching data:", err);
            setLoading(false);
        }
    };

    const filteredForms = formsData.filter(
        (form) =>
            form?.txnId?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            form?.mobileNumber?.includes(searchQuery) ||
            form?.externalTxnId?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            form?.status?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            form?.merchantId?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const getStatusBadge = (status) => {
        const statusColors = {
            'SUCCESS': 'bg-green-100 text-green-800',
            'FAILED': 'bg-red-100 text-red-800',
            'PENDING': 'bg-yellow-100 text-yellow-800',
            'WALLET_CREDIT_FAILED': 'bg-red-100 text-red-800'
        };
        
        return (
            <span className={`px-2 py-1 rounded-full text-xs font-medium ${statusColors[status] || 'bg-gray-100 text-gray-800'}`}>
                {status}
            </span>
        );
    };

    const getSettleStatusBadge = (settleStatus) => {
        const statusColors = {
            'SUCCESS': 'bg-green-100 text-green-800',
            'FAILED': 'bg-red-100 text-red-800',
            'PENDING': 'bg-yellow-100 text-yellow-800',
            'INITIATED': 'bg-blue-100 text-blue-800'
        };
        
        return (
            <span className={`px-2 py-1 rounded-full text-xs font-medium ${statusColors[settleStatus] || 'bg-gray-100 text-gray-800'}`}>
                {settleStatus}
            </span>
        );
    };

    const getTxnModeColor = (txnMode) => {
        return txnMode === 'CW' ? 'text-blue-600 font-semibold' : 'text-purple-600 font-semibold';
    };

    return (
        <div className="min-h-screen p-6 bg-gray-100">
            <div className="flex items-center mb-6">
                <SearchBar
                    placeholder="Search by Txn ID, Mobile, External Txn ID, Status, or Merchant ID"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>

            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1 }}
                className="bg-white p-8 rounded-lg shadow-2xl"
            >
                <div className="w-full text-black p-4 rounded-lg shadow-2xl text-xl font-semibold text-center mb-4">
                    <strong>AEPS TRANSACTION DETAILS</strong>
                </div>

                {loading ? (
                    <div className="text-center text-gray-600 text-lg">Loading data...</div>
                ) : filteredForms.length === 0 ? (
                    <div className="text-center text-red-500 text-lg">No data found</div>
                ) : (
                    <Pagination
                        items={filteredForms}
                        itemsPerPage={itemsPerPage}
                        currentPage={currentPage}
                        onPageChange={setCurrentPage}
                        renderItems={(currentItems) => (
                            <div className="overflow-x-auto">
                                <table className="min-w-full bg-white border-collapse shadow-xl rounded-lg">
                                    <thead>
                                        <tr className="bg-teal-600 text-white text-left text-sm">
                                            <th className="px-4 py-3 border-b rounded-tl-lg">Txn ID</th>
                                            <th className="px-4 py-3 border-b ">Created At</th>
                                            <th className="px-4 py-3 border-b ">Aadhaar Number</th>
                                            <th className="px-4 py-3 border-b">Mobile Number</th>
                                            <th className="px-4 py-3 border-b">Merchant Mobile Number</th>
                                            <th className="px-4 py-3 border-b">Txn Mode</th>
                                            <th className="px-4 py-3 border-b">Amount</th>
                                            <th className="px-4 py-3 border-b">Bank Name</th>
                                            <th className="px-4 py-3 border-b">Status</th>
                                            <th className="px-4 py-3 border-b">Updated At</th>
                                            <th className="px-4 py-3 border-b">Bank RRN</th>
                                            <th className="px-4 py-3 border-b rounded-tr-lg">Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItems.map((form, index) => (
                                            <tr
                                                key={index}
                                                className="text-gray-800 bg-gray-50 hover:bg-gray-100 transition duration-300"
                                            >
                                                
                                                <td className="px-4 py-3 border-b font-medium text-blue-600">
                                                    {form?.txnId}
                                                </td>
                                                <td className="px-4 py-3 border-b text-sm">
                                                    {form?.created_at ? new Date(form.created_at).toLocaleString('en-IN', {
                                                        year: 'numeric',
                                                        month: '2-digit',
                                                        day: '2-digit',
                                                        hour: '2-digit',
                                                        minute: '2-digit'
                                                    }) : '-'}
                                                </td>
                                                <td className="px-4 py-3 border-b font-mono text-sm">
                                                    {form?.aadhaarNumber || '-'}
                                                </td>
                                                <td className="px-4 py-3 border-b font-mono text-sm">
                                                    {form?.mobileNumber || '-'}
                                                </td>
                                                 <td className="px-4 py-3 border-b font-mono text-sm">
                                                    {form?.merchantMobileNumber || '-'}
                                                </td>
                                                <td className="px-4 py-3 border-b">
                                                    <span className={getTxnModeColor(form?.txn_Mode)}>
                                                        {form?.txn_Mode === 'CW' ? 'Cash Withdrawal' : 'Mini Statement'}
                                                    </span>
                                                </td>
                                                <td className="px-4 py-3 border-b text-right font-medium text-green-600">
                                                    ₹{form?.amount?.toFixed(2) || '0.00'}
                                                </td>
                                                <td className="px-4 py-3 border-b text-sm">
                                                    {form?.bank_name || '-'}
                                                </td>
                                                <td className="px-4 py-3 border-b">
                                                    {getStatusBadge(form?.status)}
                                                </td>
                                                <td className="px-4 py-3 border-b text-sm">
                                                    {form?.updated_at ? new Date(form.updated_at).toLocaleString('en-IN', {
                                                        year: 'numeric',
                                                        month: '2-digit',
                                                        day: '2-digit',
                                                        hour: '2-digit',
                                                        minute: '2-digit'
                                                    }) : '-'}
                                                </td>
                                                <td className="px-4 py-3 border-b font-mono text-sm">
                                                    {form?.bankRRN || '-'}
                                                </td>
                                                <td className="px-4 py-3 border-b text-sm max-w-xs truncate">
                                                    {form?.description || '-'}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    />
                )}
            </motion.div>
        </div>
    );
};

export default AespTxn;